import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=49ee4d30&"
import script from "./commodity.vue?vue&type=script&lang=js&"
export * from "./commodity.vue?vue&type=script&lang=js&"
import style0 from "./commodity.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports